














































import { Component, Vue, Watch } from 'vue-property-decorator'
import { Getter } from 'vuex-class'

// Enums
import { ItemType } from '@/enums/ItemEnums'

// Models
import Category from '@/models/Category'

// Components
import ImageViewer from '@/components/common/ImageViewer.vue'

@Component({
  components: {
    ImageViewer
  }
})
export default class ItemCategoriesBox extends Vue {
  type = null
  categories = []
  subCategories = []
  templates = []

  category = null
  subCategory = null

  isLoading = false
  step = 1
  selectedCategory = null
  selected = null

  @Getter('token') token
  @Getter('locale', { namespace: 'user' }) locale

  @Watch('type')
  emitEvent() {
    this.$emit('select', {
      category: -1,
      type: this.type
    })
  }

  // @Watch('subCategory')
  // emitEvent() {
  //   this.$emit('select', {
  //     category: this.category,
  //     subCategory: this.subCategory,
  //     type: this.type
  //   })
  // }

  async mounted() {
    try {
      this.isLoading = true
      const res = await this.$api.templates.fetchTemplatesByCategory(this.token)
      this.categories = res.data.length ? res.data.map((item) => new Category(item, this.locale)) : []
    } finally {
      this.isLoading = false
    }
  }

  get stepTitle() {
    if (this.step === 1) {
      return this.$t('item.add.category.title')
    }
    if (this.step === 2) {
      return this.$t('item.add.subcategory.title')
    }
  }

  get currentCagories() {
    if (this.step === 1) {
      return this.categories
    }
    if (this.step === 2) {
      return this.subCategories
    }
  }

  goToStep(step) {
    this.step = step
  }

  selectCategory(item) {
    if (this.step === 1) {
      this.category = item
      this.subCategories = item.subCategories
    }
    if (this.step === 2) {
      this.subCategory = item
    }
    if (this.step < 2) {
      this.step++
    }
  }

  selectTypeOthers() {
    this.type = ItemType.Others
  }

  selectTypeCar() {
    this.type = ItemType.Car
  }
  selectTypeRealty() {
    this.type = ItemType.Realty
  }
}
